import type { FeatureModule } from '@/shell/registry/types'

export default {
  code: 'calendar',
  title: '日程与会议',
  routes: [
    { path: '/calendar', name: 'calendar', component: () => import('./CalendarView.vue'), meta: {} },
    /* 历史会议专属页：独立于「日程与会议」页签，由会议面板头部入口进入 */
    { path: '/calendar/meeting-history', name: 'meetingHistory', component: () => import('./meeting/MeetingHistoryView.vue'), meta: { title: '历史会议' } },
  ],
} satisfies FeatureModule
